export const API_VERSION = Object({
   // 'dev': '/2021/sigrental/api/public/api/v1',
    //'dev': '/2023/SignalRentals - 2/api/public/api/v1',
    'dev': '/backend/api/v1',
    // http://localhost/2020/rental/api/public/api/v1/
    // 'prod': '/backend/api/v1',
    'prod': '/backend/api/v1'
});
